export const getCity = ({ city }) => {
  return { city };
};

export const getLocations = ({ locations }) => {
  return { locations };
};
